import React from "react";
import {Button, Form, Input} from "antd";
import i18next from "i18next";
// import {useLocation} from "react-router-dom";
import {rsoFastLogin} from "../backend/RsoBackend";
import ValidationError from "../common/ValidationError";
// import {RsoCaptchaSmartLogin} from "../common/RsoCaptchaSmartLogin";
import * as Setting from "../Setting";
import RsoSendCodeOtp from "../common/RsoSendCodeOtp";

class FastLoginForm extends React.Component {
  constructor(props) {
    super(props);
    this.formRef = React.createRef();
    this.state = {
      captchaToken: "",
      captchaImg: "",
      captchaType: "Default",
      clientSecret: "",
      isOtpSent: false,
      otpCode: "",
      phone: "",
    };
  }

  setCaptchaToken = (token) => {
    this.setState({captchaToken: token});
  };

  setCaptchaImg = (img) => {
    this.setState({captchaImg: img});
  };

  setClientSecret = (secret) => {
    this.setState({clientSecret: secret});
  };

  handleOtpSent = () => {
    this.setState({isOtpSent: true});
  };
  handleLogin = async() => {
    const {phone, otpCode, captchaToken} = this.state;
    const {application} = this.props;

    if (!phone || !otpCode || otpCode.length !== 6) {
      Setting.showMessage("error", i18next.t("general:Please enter a valid OTP code"));
      return;
    }
    const urlParams = new URLSearchParams(window.location.search);
    const redirectUri = urlParams.get("redirect_uri");
    await rsoFastLogin(
      "built-in",
      phone,
      application?.name || "app-built-in",
      otpCode,
      captchaToken,
      "IR",
      redirectUri,
      window.location
    );
  };
  render() {
    const {application, loading} = this.props;
    const {captchaToken, isOtpSent, otpCode, phone} = this.state;

    return (
      <Form
        ref={this.formRef}
        layout="vertical"
        style={{maxWidth: "400px", margin: "auto"}}
        onValuesChange={(changedValues) => {
          if (changedValues.phone) {
            this.setState({phone: changedValues.phone});
          }
        }}
      >
        <Form.Item
          name="phone"
          label={i18next.t("general:Phone")}
          rules={[
            {
              required: true,
              message: <ValidationError text={i18next.t("general:Phone is required")} />,
            },
            {
              validator: (_, value) => {
                const regex = /^0\d{10}$/;
                return regex.test(value || "")
                  ? Promise.resolve()
                  : Promise.reject(
                    <ValidationError text={i18next.t("general:Phone number must start with 0 and be 11 digits")} />
                  );
              },
            },
          ]}
        >
          <Input
            maxLength={11}
            placeholder={i18next.t("general:Enter your mobile number")}
            onChange={(e) => this.setState({phone: e.target.value})}
          />
        </Form.Item>

        {/* ارسال کد */}
        <Form.Item name="otp_code">
          <RsoSendCodeOtp
            isOtpSent={isOtpSent}
            disabled={!captchaToken || captchaToken.length !== 5}
            method="fastLogin"
            onButtonClickArgs={[phone, "phone", "admin/" + (application?.name || "admin/app-built-in")]}
            onSend={this.handleOtpSent}
            placeholder={i18next.t("general:Enter verification code")}
            value={otpCode}
            onChange={(otpCode) => this.setState({otpCode})}
            application={application}
            countryCode={"IR"}
          />
        </Form.Item>

        {/* دکمه ورود */}
        <Form.Item>
          <Button
            type="primary"
            htmlType="button"
            loading={loading}
            block
            disabled={!isOtpSent || otpCode.length !== 6}
            onClick={this.handleLogin}
          >
            {i18next.t("general:Login")}
          </Button>
        </Form.Item>

        <div style={{marginTop: "15px", textAlign: "right"}}>
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              localStorage.removeItem("fastLogin");
              window.location.reload();
            }}
          >
            {i18next.t("general:Login/SignUp")}
          </a>
        </div>
      </Form>
    );
  }
}

export default FastLoginForm;
